(()=>{
 function init(root=document){
 root.querySelectorAll('[data-vn-card]').forEach(card=>{
  if(card.dataset.vnReady)return;card.dataset.vnReady='true';
  card.querySelectorAll('[data-vn-swatch]').forEach(button=>button.addEventListener('click',()=>{
   const image=card.querySelector('.v-collection-image img');
   if(image&&button.dataset.image){image.removeAttribute('srcset');image.src=button.dataset.image;image.alt=button.dataset.color+' '+card.dataset.title;}
   card.querySelectorAll('a').forEach(a=>{if(button.dataset.url)a.href=button.dataset.url;});
   card.querySelectorAll('[data-vn-swatch]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));
   card.querySelector('[data-vn-color-label]').textContent=button.dataset.color;
  }));
 });
 root.querySelectorAll('[data-vn-play]').forEach(button=>{
  if(button.dataset.vnReady)return;button.dataset.vnReady='true';
  button.addEventListener('click',()=>{const wrap=button.closest('[data-vn-video]'),v=document.createElement('video');v.controls=true;v.playsInline=true;v.preload='none';v.src=wrap.dataset.vnVideo;v.setAttribute('aria-label','Vorson Ultra Thin Stand product demonstration');const poster=button.querySelector('img');if(poster)v.poster=poster.currentSrc;button.hidden=true;wrap.append(v);v.play().catch(()=>{});});
 });
 }
 init();document.addEventListener('DOMContentLoaded',()=>{const color=new URLSearchParams(location.search).get('color');if(color){const choice=[...document.querySelectorAll('[data-v-color]')].find(b=>b.dataset.vColor===color);choice?.click();}});document.addEventListener('shopify:section:load',e=>init(e.target));
})();
